module.exports = __webpack_public_path__ + "img/order_list_bg.24056d8c.png";